import React from "react";
import Link from "next/link";
import {MwSmallIcon} from "../icons";
import { useTranslation } from "next-i18next";
import "../../../styles/scss/solutions.module.scss";

type Props = {
    title: React.ReactNode;
    tag: string;
    description: React.ReactNode;
    cardData: cardDataItem[];
    className?: string;
};

type cardDataItem = {
    title: string;
    description: string;
}

const SolutionsHeroSection: React.FC<Props> = ({ title, tag, description, cardData }) => {
    const { t } = useTranslation("common");
    return (
        <>
            <section className={`hero-section solutions-child-page`}>
                <div className={'container'}>
                    <div className={'section-tag testimonial pd-right'}><MwSmallIcon/> {tag}</div>
                    {title}
                    {description}

                    <div className="solutions-card">
                        <div className="d-flex gradient-border-bottom gradient-border-top">
                            {cardData.map((item, index) => (
                                <div className="card" key={index}>
                                    <h4 className="text-gradient">{item.title}</h4>
                                    <p>{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={"d-flex"}>
                        <Link href={"/demo-request/"} target={"_blank"}
                              className={"sign-up ahref-btn primary"}>{t('cta.getDemo')}</Link>
                        <Link href={'#know-more'} className={"sign-up ahref-btn secondary"}>{t('cta.KnowMore')}</Link>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SolutionsHeroSection;